import React, { FC, MouseEvent } from 'react';
import { getDate } from '../../../../utils/helpers/date-helper';

interface IProps {
  notification: {
    senderName: string;
    message: string;
    createdAt: string;
  };
  onOpen: () => void;
  onClose: (event: MouseEvent<HTMLElement>) => void;
}

const Notification: FC<IProps> = ({ notification, onOpen, onClose }): JSX.Element =>{
  const { senderName, message, createdAt } = notification;
  return (
    <div className="chat-notification" onClick={onOpen} aria-hidden="false" tabIndex={0} role="button" aria-pressed="false">
      <div className="chat-notification__header" role="heading" aria-level={2}>
        <div className="chat-notification__header_user-info">
          <div className="chat-notification__header_name">{senderName}</div>
          <time className="chat-notification__header_time" dateTime={createdAt}>
            {getDate(createdAt)}
          </time>
        </div>
        <span role="button" className="chat-notification__close-btn" onClick={onClose}/>
      </div>
      <div className="chat-notification__body">
        <div className="chat-notification__body_message">
          {message}
        </div>
      </div>
    </div>
  );
};

export default Notification;
